export const DATE_FORMAT = 'yyyy/MM/dd';

export const MILLISECONDS_PER_DAY = 86400000;
